import Request from "@/helpers/services/request.service";

const UserManagementService = {
    users: async function () {
        const requestData = {
            method: "get",
            url: "/api/users",
        };
        return Request(requestData);
    },
    groupSelectList: async function () {
        const requestData = {
            method: "get",
            url: "/api/groups/selectlist",
        };
        return Request(requestData);
    },
    networks: async function () {
        const requestData = {
            method: "get",
            url: "/api/networks/selectlist",
        };
        console.log('networkselect', requestData);
        return Request(requestData);
    },
    addUser: async function (user, groups) {
        user.groupids = groups;
        const requestData = {
            method: "post",
            url: "/api/user",
            data: user
        };
        return Request(requestData);
    },
    deleteUser: async function (id) {
        console.log('delete', id);
        const requestData = {
            method: "post",
            url: "/api/user/delete",
            data: { 'Id': id }
        };
        return Request(requestData);
    },
    updateUser: async function(user) {
        const requestData = {
            method: "post",
            url: "/api/user/update",
            data: user
        };
        return Request(requestData);
    },
    updateGroupNetworkList: async function (networkids, groupid) {
        const requestData = {
            method: "post",
            url: "/api/groups/networks/update",
            data: { 'networkids': networkids, 'groupid': groupid }
        };
        return Request(requestData);
    },
    addGroup: async function (group) {
        console.log(group);
        const requestData = {
            method: "post",
            url: "/api/group",
            data: group 
        };
        return Request(requestData);
    }
};

export default UserManagementService;
